import { useCallback, useMemo } from "react";
import { trackCreditDialog, trackCreditDialogAction, trackLearnMore, } from "../analytics/events";
import { useDialogExitTracking, } from "./useDialogExitTracking";
const SHARED_PORT_TRACKERS = {
    onShown: trackCreditDialog,
    onExit: trackCreditDialogAction,
    onLearnMore: trackLearnMore,
};
/**
 * Shown-and-exit tracking for the gate dialogs. The latch lives in
 * useDialogExitTracking, shared with the club-import nudges so a third exit
 * value added on one platform cannot split the funnels.
 */
export const useCreditDialogTracking = ({ context, featureId, reason }, trackers = SHARED_PORT_TRACKERS) => {
    const params = useMemo(() => ({ context, featureId, reason }), [context, featureId, reason]);
    const { trackExit } = useDialogExitTracking(params, trackers);
    /** The one exit that also has its own event, shared with the SBC panel. */
    const trackLearnMoreClick = useCallback(() => {
        trackers.onLearnMore(params);
        trackExit("positive");
    }, [trackers, params, trackExit]);
    return { trackExit, trackLearnMoreClick };
};
//# sourceMappingURL=useCreditDialogTracking.js.map